module.exports = __webpack_public_path__ + "static/media/perspective-taking-large.f9c3b5a5.png";